var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"iframe_dashboard",attrs:{"title":"Report Section","src":_vm.iFrame,"frameborder":"0","allowFullScreen":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }